export const PDF_LESSONS_PT = [
  {
    id: 'pdf-1',
    numero: 1,
    titre: "Abrir e ler um ficheiro PDF",
    sousTitre: "O essencial",
    contexte: "Recebeu um ficheiro PDF e não sabe como abri-lo. Não se preocupe — é mais simples do que parece.",
    explication: [
      "**PDF** é um formato de ficheiro que preserva o aspecto do documento em qualquer dispositivo. A maioria dos documentos oficiais vem neste formato.",
      "**No computador**: faça duplo clique no ficheiro — abre automaticamente. Se não abrir, instale o Adobe Acrobat Reader gratuitamente.",
      "**No telemóvel**: o PDF abre directamente ao tocar nele. No iPhone abre com a aplicação Ficheiros, no Android com a aplicação Files.",
      "**Zoom**: use Ctrl+ no computador ou dois dedos no telemóvel para ampliar o texto se estiver pequeno.",
      "**Se não conseguir abrir**: verifique a ligação à internet e confirme que o ficheiro terminou de transferir — um ficheiro parcialmente transferido não abre.",
    ],
    question: "Como ampliar um texto num ficheiro PDF no telemóvel?",
    options: [
      { id: 'a', text: "Colocando dois dedos e afastando-os no ecrã", correct: true },
      { id: 'b', text: "Apenas com duplo toque, sem outra forma", correct: false },
      { id: 'c', text: "Não é possível ampliar PDF no telemóvel", correct: false },
    ],
    explication_reponse: "O gesto de zoom com dois dedos funciona em todos os smartphones. Também pode fazer duplo toque para um zoom rápido.",
  },
  {
    id: 'pdf-2',
    numero: 2,
    titre: "Preencher um formulário PDF",
    sousTitre: "Sem imprimir",
    contexte: "Tem de preencher um formulário PDF e enviá-lo. Como fazê-lo directamente no computador?",
    explication: [
      "**Formulários PDF interactivos**: têm campos onde pode clicar para escrever directamente. Procure os campos azuis ou rectângulos.",
      "**Tecla Tab**: passa de um campo para o seguinte rapidamente sem usar o rato de cada vez.",
      "**Se o PDF for uma imagem**: os campos não são clicáveis. Solução: imprima, preencha à mão e depois digitalize.",
      "**Guardar**: após o preenchimento, Ctrl+S para guardar o ficheiro preenchido no seu computador. Não se esqueça de guardar antes de enviar!",
      "**Ferramentas gratuitas**: em ilovepdf.com pode preencher PDFs directamente no navegador sem instalar nenhum programa.",
    ],
    question: "Um formulário PDF não tem campos clicáveis. Qual é a solução?",
    options: [
      { id: 'a', text: "Imprimir, preencher à mão, digitalizar e enviar", correct: true },
      { id: 'b', text: "Não é possível preenchê-lo de forma alguma", correct: false },
      { id: 'c', text: "Abri-lo no Word e preenchê-lo aí", correct: false },
    ],
    explication_reponse: "Um PDF-imagem não pode ser preenchido digitalmente. Imprimir e escrever à mão é a solução clássica. A alternativa é usar uma ferramenta como ilovepdf.com que por vezes permite adicionar texto.",
  },
  {
    id: 'pdf-3',
    numero: 3,
    titre: "Assinar um PDF",
    sousTitre: "3 métodos legais",
    contexte: "Um documento precisa da sua assinatura. A assinatura electrónica é legal em França? Sim — veja como.",
    explication: [
      "**A assinatura electrónica é legal** em França desde 2000. Aceite para a maioria dos documentos administrativos e comerciais.",
      "**Método 1**: no Adobe Acrobat → 'Preencher e assinar' → desenhe a assinatura com o rato ou insira-a como imagem.",
      "**Método 2**: imprima, assine à mão, digitalize com o telemóvel, envie o PDF digitalizado.",
      "**Método 3**: em ilovepdf.com ou smallpdf.com — ferramentas de assinatura gratuitas no navegador.",
      "**Assinatura qualificada**: para documentos muito sensíveis (contratos, actas), use um serviço como DocuSign ou Yousign.",
    ],
    question: "A assinatura electrónica num PDF é legal em França?",
    options: [
      { id: 'a', text: "Sim, é legal desde 2000", correct: true },
      { id: 'b', text: "Não, apenas a assinatura manual é aceite", correct: false },
      { id: 'c', text: "Sim, mas apenas para documentos pessoais e não administrativos", correct: false },
    ],
    explication_reponse: "A assinatura electrónica é legal em França e na União Europeia. Aceite para a maioria dos documentos. Para documentos muito sensíveis, use um serviço de assinatura qualificada.",
  },
  {
    id: 'pdf-4',
    numero: 4,
    titre: "Enviar um PDF por email",
    sousTitre: "Anexo com sucesso",
    contexte: "O ficheiro está pronto. Como anexá-lo ao email e garantir que chegou correctamente?",
    explication: [
      "**Anexar o ficheiro**: no seu email, clique no ícone do clipe 📎, procure o PDF no computador, clique nele.",
      "**Tamanho máximo**: a maioria dos servidores de email aceita anexos até 5 megabytes. Se for maior, use ilovepdf.com para comprimir.",
      "**Verificar antes de enviar**: confirme que o ficheiro aparece como anexo (o nome aparece por baixo do email) antes de clicar em enviar.",
      "**Nome do ficheiro**: dê ao ficheiro um nome claro antes de enviar — por exemplo 'JustificativoMorada_NomeApelido.pdf' em vez de 'scan001.pdf'.",
      "**Pedir confirmação de recepção**: para documentos importantes, peça ao destinatário uma confirmação de recepção — ou use a opção 'pedir confirmação de leitura'.",
    ],
    question: "Um ficheiro PDF pesa 8 megabytes. Como o enviar por email?",
    options: [
      { id: 'a', text: "Comprimi-lo primeiro em ilovepdf.com e depois enviá-lo", correct: true },
      { id: 'b', text: "Enviá-lo tal como está — o email comprime automaticamente", correct: false },
      { id: 'c', text: "Não é possível enviar um PDF deste tamanho", correct: false },
    ],
    explication_reponse: "ilovepdf.com comprime PDFs gratuitamente sem perda de qualidade. Após a compressão, o tamanho reduz normalmente para menos de 2 megabytes — fácil de enviar.",
  },
];
